import type { I18nFeatureBundle } from '@/lib/i18n/types'

import { en } from './en'
import { lo } from './lo'

/** All landing-page copy, in every supported language. The default namespace. */
export const landingI18n = {
  namespace: 'landing',
  resources: { en, lo },
} as const satisfies I18nFeatureBundle
